module.exports = __webpack_public_path__ + "img/dis_point3.4aa8655c.png";